// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { Feature } from './feature';
import { ProductFeatureChoice } from './product-feature-choice';
import { StagedProductColor } from './staged-product-color';
import { StagedProductPart } from './staged-product-part';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class FeatureChoice extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** Int32 */
  cOL_KEY?: number;
  /** String(50) */
  choiceValue!: string;
  /** Int32 */
  displayOrder!: number;
  /** Int32 FK feature */
  featureId!: number;
  /** Int32 FK reorderFeatureChoice */
  reorderFeatureChoiceId?: number;
  /** String(50) */
  _origChoiceValue?: string;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** FK featureId */
  feature!: Feature;
  /** Inv FK reorderFeatureChoiceId */
  inverseReorderFeatureChoice!: FeatureChoice[];
  /** Inv FK featureChoiceId */
  productFeatureChoices!: ProductFeatureChoice[];
  /** FK reorderFeatureChoiceId */
  reorderFeatureChoice!: FeatureChoice;
  /** Inv FK featureChoiceId */
  stagedProductColors!: StagedProductColor[];
  /** Inv FK featureChoiceId */
  stagedProductParts!: StagedProductPart[];
}

